import script from "./StateContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StateContactForm.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./StateContactForm.vue?vue&type=style&index=0&id=2210d8fe&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-2210d8fe"]])

export default __exports__